module.exports = __webpack_public_path__ + "img/FR17569.d314d080.svg";